import { useEffect } from 'react';
export const useOutsideClick = (ref, handler, mouseEvent = 'mouseup') => {
    useEffect(() => {
        const listener = (e) => {
            const el = ref.current;
            if (el === null || el.contains(e.target)) {
                return;
            }
            handler(e);
        };
        document.addEventListener(mouseEvent, listener);
        return () => {
            document.removeEventListener(mouseEvent, listener);
        };
    }, [ref, handler, mouseEvent]);
};
//# sourceMappingURL=useOutsideClick.js.map